import { Text } from '@chakra-ui/react';

function DataDisclaimer(props) {
  // eslint-disable-next-line no-unused-vars
  const { children, ...rest } = props;
  return (
    <Text py={4} fontSize="xs" className="hidden-print" {...rest}>The information presented in these dashboards is based on the latest data that is currently available and is being updated regularly.</Text>
  );
}

export default DataDisclaimer;
